import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconAxisYSizeS from './IconAxisY_size_s';

const props: CreateIconArguments = {
  l: IconAxisYSizeS,
  m: IconAxisYSizeS,
  s: IconAxisYSizeS,
  xs: IconAxisYSizeS,
  name: 'IconAxisY',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
